module.exports = __webpack_public_path__ + "static/media/na.ec85425f.png";